import omit from 'lodash.omit'
import { triggerSearch, setFilters, setSearchResultsView } from 'map/actions'
import * as constants from 'map/constants'
import * as selectors from 'map/selectors'
import ResultsList from 'map/components/resultList/'
import Filters from 'map/components/filters'
import ResultListHeader from 'map/components/resultListHeader'
import FilterChipContainer from 'map/components/filterChipContainer'
import styles from './styles.module.scss'

const SearchResults = ({ filters, resultsCount, setFilters, triggerSearch, setSearchResultsView, resultsMode }) => {
    const clearFilters = () => {
        setFilters({})
        triggerSearch()
    }

    const removeFilter = filter => {
        setFilters(omit(filters, filter))
        triggerSearch()
    }

    const toggleResultsView = () => {
        const mode =
            resultsMode === constants.SHOW_MAP_SEARCH_FILTERS
                ? constants.SHOW_MAP_SEARCH_RESULTS
                : constants.SHOW_MAP_SEARCH_FILTERS

        setSearchResultsView(mode)
    }

    const showFilters = constants.SHOW_MAP_SEARCH_FILTERS === resultsMode

    return (
        <div className={styles.results}>
            <div>
                <ResultListHeader resultsCount={resultsCount} toggleFilter={toggleResultsView} active={showFilters} />
                <FilterChipContainer filters={filters} removeFilter={removeFilter} clearFilters={clearFilters} />
            </div>

            {showFilters ? (
                <Filters
                    toggleResultsView={toggleResultsView}
                    filters={filters}
                    setFilters={setFilters}
                    triggerSearch={triggerSearch}
                />
            ) : (
                <ResultsList />
            )}
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    filters: selectors.filtersSelector,
    resultsCount: selectors.resultsCountSelector,
    resultsMode: selectors.resultsModeSelector,
})

const mapDispatchToProps = {
    triggerSearch,
    setFilters,
    setSearchResultsView,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults)
